import { useState, useEffect } from "react";
import { API, useAuth } from "@/App";
import axios from "axios";
import { HardDrive, X, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { useNavigate } from "react-router-dom";

export function BackupAlert() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    const checkBackup = async () => {
      // Don't show more than once per session
      if (sessionStorage.getItem("omni_backup_alert_dismissed")) return;
      try {
        const { data } = await axios.get(`${API}/backup/alert`, { headers });
        if (data.needs_backup) setAlert(data);
      } catch (err) {
        console.error("Backup alert check failed", err);
      }
    };
    checkBackup();
  }, []);

  const dismiss = () => {
    setDismissed(true);
    sessionStorage.setItem("omni_backup_alert_dismissed", "true");
  };

  if (!alert || dismissed) return null;

  return (
    <div
      data-testid="backup-alert"
      className="mx-4 mb-3 p-3.5 rounded-2xl border border-amber-400/30 bg-amber-50/80 dark:bg-amber-950/20 dark:border-amber-500/20 animate-in fade-in slide-in-from-top-2 duration-300"
    >
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-xl bg-amber-400/20 flex items-center justify-center flex-shrink-0">
          <HardDrive className="w-4 h-4 text-amber-600 dark:text-amber-400" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold text-amber-800 dark:text-amber-300">Backup Overdue</p>
          <p className="text-[11px] text-amber-700/80 dark:text-amber-400/70 mt-0.5 leading-relaxed">
            {alert.message}
          </p>
          <button
            data-testid="backup-alert-action"
            onClick={() => { dismiss(); navigate("/settings"); }}
            className="mt-2 inline-flex items-center gap-1 text-[11px] font-semibold text-amber-700 dark:text-amber-400 hover:underline"
          >
            Back up now <ArrowRight className="w-3 h-3" />
          </button>
        </div>
        <button
          data-testid="backup-alert-dismiss"
          onClick={dismiss}
          className="p-1 rounded-full hover:bg-amber-200/50 dark:hover:bg-amber-800/30 text-amber-600/60 flex-shrink-0"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
